import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

// IPSC scoresheets of one convention (results page, TV board, RO page).
// Writes go through lib/ipscScoreQueue.js (offline op log), never through save().
class ConventionIpscScoreStore extends LocalModel {
    constructor() {
        super('conventionIpscScore', {
            namePlural: 'conventionIpscScores',
            namePluralReal: 'conventionipscscores',
            sort: 'stand',
            limit: 50000,
            api: {
                search: {
                    url: '/api/conventionipscscores/',
                    params: {
                        limit: 50000,
                        sort: 'stand',
                    },
                },
                load: {
                    url: '/api/conventionipscscores/',
                    params: {},
                },
                save: {
                    url: '/api/conventionipscscores/',
                    params: {},
                },
                delete: {
                    url: '/api/conventionipscscores/',
                    params: {},
                },
            },
        });
    }

    @observable conventionIpscScore = {};

    @observable conventionIpscScores = [];

    @observable history = [];

    // Not observable: which convention the loaded list belongs to.
    loadedConvention = 0;

    @action
    async loadForConvention(conventionId) {
        const id = parseInt(conventionId, 10) || 0;
        if (!id) {
            return null;
        }
        const response = await util.fetchApi('/api/conventionipscscores/', { method: 'GET' }, { convention: id });
        if (response?.status === 200) {
            this.loadedConvention = id;
            this.updateKeyValue('conventionIpscScores', response.data?.conventionipscscores || []);
        }
        return response;
    }

    @action
    async loadHistory(id) {
        const response = await util.fetchApi(`/api/conventionipscscores/${id}/history`, { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('history', response.data?.history || []);
        } else {
            this.updateKeyValue('history', []);
        }
        return response;
    }

    async approve(id, { approvedByName, version }) {
        return util.fetchApi(`/api/conventionipscscores/${id}/approve`, { method: 'POST' }, {
            id, approvedByName, version,
        });
    }

    sheetFor({ participant, division, stand }) {
        const pid = Number(participant);
        const st = Number(stand);
        return this.conventionIpscScores.find(s => Number(s.participant) === pid && s.division === division && Number(s.stand) === st) || null;
    }

    // Officials remove a sheet (orphan rows after a division change). Soft delete server-side.
    async removeSheet(id) {
        const response = await util.fetchApi(`/api/conventionipscscores/${id}`, { method: 'DELETE' }, { id });
        if (response?.status >= 200 && response?.status < 300 && this.loadedConvention) {
            await this.loadForConvention(this.loadedConvention);
        }
        return response;
    }
}

const store = new ConventionIpscScoreStore();

export default store;
